import React, { useState, useEffect } from "react";
import { Modal, Button, Input, message, Tooltip } from "antd";
import { connect } from "react-redux";
import { ReloadOutlined } from "@ant-design/icons";
import chatImg from "../../../assets/img/chat-lines.svg";
import moment from "moment";

const { TextArea } = Input;

const CommentRow = ({ comment }) => (
  <div className="py-3 first:pt-0 last:pb-0">
    <div className="flex items-baseline gap-2 mb-1">
      <span className="text-[12px] font-semibold text-[#0F1A24] text-capitalize">
        {comment.first_name || "Coach"} {comment.last_name || ""}
      </span>
      <span className="text-[11px] text-[#A9B6C2] whitespace-nowrap">
        {moment(comment.created_at).fromNow()}
      </span>
    </div>
    <p className="mb-0 text-[12px] leading-[20px] text-[#526B84] whitespace-pre-wrap">
      {comment.comment}
    </p>
  </div>
);

const Collaboration = (props) => {
  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState("");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [commentsLoading, setCommentsLoading] = useState(false);

  const handleGetComments = () => {
    if (!props.play?.id) return;
    setCommentsLoading(true);
    props.getCommentsForPlay({
      params: { id: props.play.id },
      callback: (res, data) => {
        if (res === true) {
          const sortedItems = data?.data?.sort((a, b) => {
            return moment(a.created_at).isBefore(moment(b.created_at)) ? 1 : -1;
          });
          setComments(sortedItems || []);
        }
        setCommentsLoading(false);
      },
    });
  };

  useEffect(() => {
    setComments([]);
  }, [props.play?.id]);

  const handleAddComment = () => {
    if (!newComment) return message.warning("Comment cannot be empty");
    setLoading(true);
    props.addComment({
      body: {
        comment: newComment,
        play: props.play.id,
        user: props.coachProfile?.user?.id,
        game: props.game,
      },
      callback: (res, data) => {
        if (res) {
          setNewComment("");
          handleGetComments();
          message.success("Comment added successfully");
        }
        setLoading(false);
      },
    });
  };

  const showModal = () => {
    setIsModalVisible(true);
    handleGetComments();
  };
  const handleCancel = () => setIsModalVisible(false);

  const handleArchiveComment = (commentId) => {
    props.archiveComment({
      body: { id: commentId },
      callback: (res, data) => {
        if (res) {
          handleGetComments();
          message.info(`Comment archived!`);
        }
        setLoading(false);
      },
    });
  };

  return (
    <>
      <Tooltip title="Coaches Chat">
        <img
          src={chatImg}
          className="w-[24px] cursor-pointer"
          onClick={showModal}
        />
        <div className="flex relative w-[30%]">
            {comments && comments?.length > 0 ? (  
            <div
              className={`absolute bottom-[15px] left-[15px] 
                bg-red-500 animate-bounce
                px-[8px] py-[4px] text-white rounded-full text-[10px] flex items-center justify-center `}
            >
              {comments?.length}
            </div>
           ) : (
            ""
          )}  
        </div>
      </Tooltip>
      <Modal
        title={
          <span className="text-[14px] font-semibold text-[#0F1A24]">
            Collaborations on play {props.play?.number}
          </span>
        }
        open={isModalVisible}
        onCancel={handleCancel}
        footer={null}
        centered
        width={520}
      >
        <div className="max-h-[320px] overflow-y-auto divide-y divide-[#EAEDF0]">
          {comments.length ? (
            comments.map((comment, i) => (
              <CommentRow key={comment.id ?? i} comment={comment} />
            ))
          ) : (
            <p className="mb-0 py-2 text-[12px] text-[#A9B6C2]">
              {commentsLoading ? "Loading…" : "No collaborations yet"}
            </p>
          )}
        </div>

        <div className="mt-2 flex justify-end">
          <button
            type="button"
            onClick={handleGetComments}
            disabled={commentsLoading}
            aria-label="Refresh collaborations"
            className="inline-flex items-center gap-1.5 bg-transparent border-0 py-1 px-0.5 cursor-pointer disabled:cursor-not-allowed text-[12px] text-[#526B84] hover:text-[#0F1A24] disabled:opacity-50"
          >
            <ReloadOutlined spin={commentsLoading} className="text-[14px]" />
            <span>Refresh</span>
          </button>
        </div>

        <div className="mt-3 pt-3 border-t border-[#EAEDF0]">
          <TextArea
            value={newComment}
            onChange={(e) => setNewComment(e.target.value)}
            placeholder="Collaborate with other coaches here…"
            rows={3}
            className="text-[12px]"
            style={{ fontSize: "12px" }}
          />
          <div className="mt-2 flex items-center justify-between gap-3">
            <span className="text-[11px] leading-[16px] text-[#A40E17]">
              Players can’t see these — coaches only
            </span>
            <Button
              type="primary"
              size="small"
              loading={loading}
              onClick={handleAddComment}
              className="bg-[#1A91FF] text-xs"
            >
              Submit
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
};

const mapStateToProps = (state) => ({
  coachProfile: state?.app?.account?.profile?.data?.details,
});

const mapDispatchToProps = (dispatch) => ({
  addComment: (details) =>
    dispatch(global.redux.action.plays.addComment(details)),
  archiveComment: (details) =>
    dispatch(global.redux.action.plays.archiveComment(details)),
  getCommentsForPlay: (details) =>
    dispatch(global.redux.action.plays.getCommentsForPlay(details)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Collaboration);
